export const formatFilter = {
    from: "start_date",
    to: 'end_date',
    area: "areas_ids",
    department: "departments_ids"
}

export const formatInputFilter = {
    from: "start_date",
    to: 'end_date',
    userId:"users_ids"
}
